var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgProfile = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 32 32"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  stroke: "currentColor",
  strokeWidth: 2
}, /*#__PURE__*/React.createElement("circle", {
  cx: 16.5,
  cy: 13.5,
  r: 4.5
}), /*#__PURE__*/React.createElement("path", {
  d: "M25.302 26.92A9.503 9.503 0 0 0 16.5 21a9.503 9.503 0 0 0-8.8 5.913"
})), /*#__PURE__*/React.createElement("circle", {
  cx: 16,
  cy: 16,
  r: 14,
  stroke: "#57E8FC",
  strokeWidth: 3
}))));

export default SvgProfile;